import React, { useState} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import translate from '../../i18n/translate';

export default function FormDialog(props) {
    const {value = "", open, setOpen, onConfirm, title, description } = props;

    const [contentValue, setContentValue] = useState(value);
    const onContentChange = (e) => setContentValue(e.target.value);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent style={{width: "25rem"}}>
                    <DialogContentText>
                        {description}
                    </DialogContentText>
                    <TextField
                        autoFocus
                        id="content"
                        label=""
                        fullWidth
                        type="name"
                        variant="standard"
                        onChange={onContentChange}
                        value={contentValue}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        onConfirm(contentValue);
                        setOpen(false);
                    }}>{translate("questionnaire.confirmer")}</Button>
                    <Button onClick={() => setOpen(false)}>{translate("questionnaire.annuler")}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
